import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import {
  MuiThemeProvider as ThemeProvider,
  StyledEngineProvider,
  Box,
  CssBaseline,
  AdapterDateFns,
  MuiPickersUtilsProvider,
} from '@the-platform-group/component-library'
import Theme from '@the-platform-group/component-library/Theme'
import { ModalProvider } from '@the-platform-group/component-library/Modal/ModalContext'

import { SessionProvider } from 'contexts/Session'
import FactsetAuthCallback from 'auth/FactsetAuthCallback'
import Logout from 'pages/Logout'
import Layout from './Layout'
import GenericErrorBoundary from 'boundaries/GenericErrorBoundary'
import ForbiddenErrorBoundary from 'boundaries/ForbiddenErrorBoundary'
import MaintenanceErrorBoundary from 'boundaries/MaintenanceErrorBoundary'
import { loadDataGridPro } from '@the-platform-group/component-library/DataGrid'
import { QueryClientProvider } from '@tanstack/react-query'
import queryClient from 'store/queryClient'
import MarketCapsErrorBoundary from 'boundaries/MarketCapsErrorBoundary'
import AuthenticationErrorBoundary from 'boundaries/AuthenticationErrorBoundary'
import { mui } from 'config'

loadDataGridPro(mui.dataGridKey)

const App = () => {
  return (
    <MuiPickersUtilsProvider dateAdapter={AdapterDateFns}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={Theme}>
          <Box
            sx={{
              display: 'flex',
            }}
          >
            <CssBaseline />
            <Router>
              <Switch>
                <Route path="/callback" component={FactsetAuthCallback} />
                <Route path="/logout" component={Logout} />
                <Route>
                  <MaintenanceErrorBoundary>
                    <GenericErrorBoundary>
                      <AuthenticationErrorBoundary>
                        <ForbiddenErrorBoundary>
                          <SessionProvider>
                            <QueryClientProvider client={queryClient}>
                              <MarketCapsErrorBoundary>
                                <ModalProvider>
                                  <Layout />
                                </ModalProvider>
                              </MarketCapsErrorBoundary>
                            </QueryClientProvider>
                          </SessionProvider>
                        </ForbiddenErrorBoundary>
                      </AuthenticationErrorBoundary>
                    </GenericErrorBoundary>
                  </MaintenanceErrorBoundary>
                </Route>
              </Switch>
            </Router>
          </Box>
        </ThemeProvider>
      </StyledEngineProvider>
    </MuiPickersUtilsProvider>
  )
}

export default App
